exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".template-attr-tab .el-tabs__content{height:276px!important;overflow-y:auto}.el-popper.tag_select-popper .el-select-dropdown__item{height:100%!important;padding:0}", ""]);

// exports
